import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocalStorage } from '../../hooks/useLocalStorage';

/** One key for every page that offers the filter, so ticking it on the Overview is still ticked on
 *  Prices & ABT — the same arrangement as useHideInactive. The pages are separate routes and never
 *  mounted together, so reading the stored value on mount is all "synced" needs. */
const STORAGE_KEY = 'budgetHidePastMonths';

/**
 * CALL-781: the shared state behind the `Vergangene Monate ausblenden` filter. Default OFF — the ticket
 * never asks for it to be on, and defaulting it on would change what every user sees on deploy.
 */
export const useHidePastMonths = () => useLocalStorage<boolean>(STORAGE_KEY, false);

interface HidePastMonthsFilterProps {
    checked: boolean;
    onChange: (value: boolean) => void;
}

/**
 * The `Vergangene Monate ausblenden` checkbox.
 *
 * Extracted once the Overview and Prices & ABT both offered it: the two must not drift on the label or
 * the storage key behind them.
 */
const HidePastMonthsFilter = ({ checked, onChange }: HidePastMonthsFilterProps) => {
    const { t } = useTranslation('budget');

    return (
        <FormControlLabel
            sx={{ m: 0 }}
            control={
                <Checkbox
                    size="small"
                    checked={checked}
                    onChange={(event) => onChange(event.target.checked)}
                    sx={{ py: 0 }}
                />
            }
            label={
                <Typography variant="body2">
                    <span>{t('filter.hidePastMonths')}</span>
                </Typography>
            }
        />
    );
};

export default HidePastMonthsFilter;
